 import React, { useState, useEffect, useMemo } from 'react';
// 💡 NEW: Import the logic from the new file
import { processChartData, formatChartOptions } from './effectsHelper'; 
import ApexChartWrapper from '../ApexChartWrapper';
import SkeletonLoader from '../../../../components/SkeletonLoader';

// REMOVED functions in useEffect: getCalendarTypes, getDevices, getLabels, getValues, getTotalCount functions

export default function Charts (props) {

    const {
      data: chartData,
      themeOptions,
      type,
      isLoading,
    } = props;

    const [chartKey, setChartKey] = useState(0);
    const { series: chartSeries, options: chartOptions } = useMemo(() => {
        
        if (!chartData?.length) {
            // Return stable empty structure
            return { series: [], options: themeOptions || {} }; 
        }
        
        // This process is now fully isolated from React's state setters.
        const processed = processChartData(chartData, type);
        const formatted = formatChartOptions(processed, themeOptions, type);
        
        // Return stable objects derived from calculation
        return { series: formatted.series, options: formatted.options };
        
    }, [chartData ]);

    // --- New Consolidated Effect ---
    useEffect(() => {
      return () => {
        setChartKey(prev => prev + 1);
      };
      
    }, [chartData, props.type, props.themeOptions]); 

    return (
      <>
      {isLoading || !chartSeries?.length
? (
        <SkeletonLoader />
      )
: (
        <ApexChartWrapper
          chartKey={chartKey}
          options={chartOptions}
          series={chartSeries}
          type='donut'
          height='200'
          stroke={''}
        />
      )}
      </>
    );
}